<template>
  <div class="zhishuNo">
    <template v-if="LatelyLpVoDetail.last">
      <div class="zs-line-box" v-if="lottery">
        <div v-show="guzhiperiods.length != 0" class="fbox zs-line" ref="zsline"></div>
        <div class="cszs">
          <p>{{ lottery.lhcDrawingZodiac ? Number(lottery.lhcDrawingZodiac).toFixed(2) : "出仓中" }}</p>
          <span v-if="lottery.lhcDrawingZodiac && zsplus" class="zsplus" :class="zsplus < 0 && 'lvle'">
            {{ zsplus }}
          </span>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { ApiqueryHisPeriodsPage } from "@/service";
import echarts from "echarts/dist/echarts.min";
export default {
  data() {
    return {
      guzhiperiods: [],
      hisPeriodsList: []
    };
  },
  props: {
    lottery: {
      type: [Object],
      default: null
    },
    LatelyLpVoDetail: {
      type: [Object],
      default: null
    }
  },
  watch: {
    lottery: {
      handler: function () {
        this.myEcharts()
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
    async getLotteryperiods() {
      const res = await ApiqueryHisPeriodsPage({
        lotteryCode: this._lotteryCode,
        limit: 20
      });
      if (res.code == "12200") {
        this.guzhiperiods = res.data.list
        this.hisPeriodsListYabo = res.data.list.length > 20 ? res.data.list.slice(0, 20) : res.data.list
      }
    },
    async myEcharts() {
      await this.getLotteryperiods()
      this.echarts = echarts.init(this.$refs.zsline);
      const records = [...this.guzhiperiods].reverse();
      const seriesDatas = records.map((item) => item.lhcDrawingZodiac);
      // 指定图表的配置项和数据
      var option = {
        xAxis: {
          type: "category",
          show: false,
        },
        yAxis: {
          scale: true,
          show: false,
          type: "value",
        },
        grid: {
          left: 0,
          top: 5,
          bottom: 5,
          right: 0,
        },
        series: [
          {
            data: seriesDatas,
            type: "line",
            showSymbol: false,
          },
        ],
        color: "red",
      };

      // 使用刚指定的配置项和数据显示图表。
      this.echarts.setOption(option);
    }
  },
  computed: {
    _lotteryCode() {
      return this.lottery.lotteryCode;
    },
    zsplus() {
      let currperiodsNumber = this.lottery.periodsNumber;
      let currindex = this.guzhiperiods.findIndex(
        (item) => item.periodsNumber == currperiodsNumber
      );
      let lastPeriods = this.guzhiperiods[currindex + 1];
      if (
        lastPeriods &&
        this.lottery.lhcDrawingZodiac != undefined
      ) {
        const numb = Number(this.lottery.lhcDrawingZodiac) - Number(lastPeriods.lhcDrawingZodiac)

        return numb > 0 ? `+${numb.toFixed(2)}` : numb.toFixed(2);
      }
      return "";
    },
  },
  created() {
    this.myEcharts()
  }
}
</script>
<style lang="less">
.zhishuNo {
  .zs-line-box {
    width: 100%;
    display: flex;

    .cszs {
      width: 100%;
      margin-top: 20px;

      p {
        font-size: 16px;
        margin-bottom: 6px;
      }
    }

    .zsplus {
      text-align: center;
      background-color: #dc3b40;
      color: #fff;
      font-size: 12px;
      border-radius: 5px;
      height: 18px;
      line-height: 18px;
      padding:3px 6px;
      &.lvle {
      background-color: #0e771b;
    }
    }

    .zs-line {
      width: 300px !important;
      height: 60px;
      margin-right: 6px;
      margin-top: 20px;
    }
  }
}
</style>